<template>
  <div class="bg-primary pb-1 pt-2.5">
    <div class="flex items-center justify-end pr-8 lg:m-auto banner:max-w-6xl banner:pr-[16px]">
      <m-router-link class="relative" :to="{ name: CUSTOMER_CART_PAGE }">
        <m-icon :icon="faCartShopping" size="lg" class="text-white hover:text-accent" />
        <m-badge v-if="itemCount" outline size="small" class="absolute -top-[4px] left-[16px] bg-white text-black">
          {{ itemCount }}
        </m-badge>
      </m-router-link>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { faCartShopping } from '@fortawesome/free-solid-svg-icons';
  import { storeToRefs } from 'pinia';
  import { useCartStore } from '@apps/customer/stores/cart.store';
  import { CUSTOMER_CART_PAGE } from '@apps/cart/routing';
  import MBadge from '../MBadge/MBadge.vue';

  const cartStore = useCartStore();
  const { itemCount } = storeToRefs(cartStore);
</script>
